import React from 'react';

const REACT_SNAP_AGENT_REGEX = /ReactSnap/;

const isSnap = REACT_SNAP_AGENT_REGEX.test(window.navigator.userAgent);

const dummyComponent = () => <div>enable javascript</div>;

export default (component) => (isSnap ? dummyComponent : component);
